import { UserReview } from 'shared/src/components/user-review/user-review.component';
import { GoalId } from './quiz';

declare const $localize: any;

export const goalsReviewsMap: Record<GoalId, UserReview[]> = {
  beMoreProductive: [
    {
      name: $localize`:@@reviewNameGoalBeMoreProductive1:Sophia Lee`,
      age: 22,
      message: $localize`:@@reviewGoalBeMoreProductive1:I used to struggle with retaining what I read in textbooks. Now, I listen to my course materials on the way to class or during gym sessions. It's incredible how much more I remember and how much time I save.`,
      avatarUrl: 'assets/img/avatars/girl1.jpg',
      rate: 5.0,
    },
    {
      name: $localize`:@@reviewNameGoalBeMoreProductive2:Justin Geidt`,
      age: 35,
      message: $localize`:@@reviewGoalBeMoreProductive2:Balancing my engineering workload and personal life felt impossible before Peech. Now, I use it daily to turn my technical readings into audio, and I've gained so much extra time for myself.`,
      avatarUrl: 'assets/img/avatars/m3.jpg',
      rate: 4.8,
    },
  ],
  learnSomethingNew: [
    {
      name: $localize`:@@reviewNameGoalLearnSomethingNew1:Alicia Green`,
      age: 54,
      message: $localize`:@@reviewGoalLearnSomethingNew1:I've always wanted to learn more about history, but never found the time to read. With Peech, I've been listening to fascinating historical content during my daily walks. It's like having a personal tutor wherever I go.`,
      avatarUrl: 'assets/img/avatars/w2.jpg',
      rate: 4.5,
    },
    {
      name: $localize`:@@reviewNameGoalLearnSomethingNew2:Thomas Brooks`,
      age: 46,
      message: $localize`:@@reviewGoalLearnSomethingNew2:I wanted to expand my knowledge but couldn't find time for reading. I started listening to short educational content on this app during my lunch break. I've learned more in the past few months than in years!`,
      avatarUrl: 'assets/img/avatars/m3.jpg',
      rate: 5.0,
    },
  ],
  listenOnTheGo: [
    {
      name: $localize`:@@reviewNameGoalListenOnTheGo1:Monica Davis`,
      age: 57,
      message: $localize`:@@reviewGoalListenOnTheGo1:My commute used to be wasted time, but now I turn it into productive learning. Listening to articles and books while driving has transformed my daily routine and helped me stay current in my field.`,
      avatarUrl: 'assets/img/avatars/w2.jpg',
      rate: 4.8,
    },
    {
      name: $localize`:@@reviewNameGoalListenOnTheGo2:Robert Leung`,
      age: 50,
      message: $localize`:@@reviewGoalListenOnTheGo2:As someone always on the move, I struggled to find time for reading. Now I listen to content while walking, driving, or doing chores. I've already finished 12 books this year just during my commute time!`,
      avatarUrl: 'assets/img/avatars/m3.jpg',
      rate: 4.5,
    },
  ],
  makeReadingEasier: [
    {
      name: $localize`:@@reviewNameGoalMakeReadingEasier1:Victoria Chang`,
      age: 48,
      message: $localize`:@@reviewGoalMakeReadingEasier1:Reading long articles used to strain my eyes and give me headaches. Converting them to audio has been life-changing. I can absorb so much more content without the eye strain.`,
      avatarUrl: 'assets/img/avatars/w2.jpg',
      rate: 4.9,
    },
    {
      name: $localize`:@@reviewNameGoalMakeReadingEasier2:Nicole Patterson`,
      age: 47,
      message: $localize`:@@reviewGoalMakeReadingEasier2:Reading was becoming difficult for me as I aged. This app helped me convert my books into audio I could listen to while walking. Now I'm flying through my reading list without any strain.`,
      avatarUrl: 'assets/img/avatars/w2.jpg',
      rate: 4.5,
    },
  ],
  everythingIsPerfect: [
    {
      name: $localize`:@@reviewNameGoalEverythingIsPerfect1:Derek Martinez`,
      age: 53,
      message: $localize`:@@reviewGoalEverythingIsPerfect1:I was forgetting what I read almost immediately. With this app, I listen to content multiple times while commuting, and my retention has improved dramatically. I can now recall key points from articles weeks later.`,
      avatarUrl: 'assets/img/avatars/m3.jpg',
      rate: 4.8,
    },
    {
      name: $localize`:@@reviewNameGoalEverythingIsPerfect2:Jezebel Levin`,
      age: 42,
      message: $localize`:@@reviewGoalEverythingIsPerfect2:As a doctor, there's so much to remember every day. Peech helped me convert medical journals into audio, which allowed me to review information repeatedly. My recall of important details has improved tremendously!`,
      avatarUrl: 'assets/img/avatars/w2.jpg',
      rate: 4.5,
    },
  ],
  adhdEyeStrainDyslexia: [
    {
      name: $localize`:@@reviewNameGoalAdhdEyeStrainDyslexia1:Evelyn Robinson`,
      age: 49,
      message: $localize`:@@reviewGoalAdhdEyeStrainDyslexia1:My vision was deteriorating, making reading physically painful. With this app, I can listen to all my favorite books and articles without any strain. It's given me back the joy of literature.`,
      avatarUrl: 'assets/img/avatars/w2.jpg',
      rate: 4.7,
    },
    {
      name: $localize`:@@reviewNameGoalAdhdEyeStrainDyslexia2:Dr. Leonard Brown`,
      age: 57,
      message: $localize`:@@reviewGoalAdhdEyeStrainDyslexia2:After developing chronic migraines that made reading impossible, I thought my academic career was over. This app has been my savior - I can still consume all the research papers I need by listening instead of reading.`,
      avatarUrl: 'assets/img/avatars/m3.jpg',
      rate: 4.5,
    },
  ],
};

export const preparationReviews: UserReview[] = [
  {
    name: $localize`:@@reviewNamePreparation1:Michael R.`,
    age: 42,
    message: $localize`:@@reviewPreparation1:I was drowning in articles I never had time to read. Now I listen while commuting and have finished more content in a month than I did all last year.`,
    avatarUrl: 'assets/img/avatars/m3.jpg',
    rate: 4.8,
  },
  {
    name: $localize`:@@reviewNamePreparation2:Sarah Keller`,
    age: 39,
    message: $localize`:@@reviewPreparation2:My eyes were constantly strained from screen time. Switching to audio has been a game-changer - I absorb information while resting my eyes.`,
    avatarUrl: 'assets/img/avatars/w2.jpg',
    rate: 5.0,
  },
  {
    name: $localize`:@@reviewNamePreparation3:James H.`,
    age: 51,
    message: $localize`:@@reviewPreparation3:The voices sound remarkably natural. I actually retain more when listening compared to reading, especially for complex topics.`,
    avatarUrl: 'assets/img/avatars/m1.jpg',
    rate: 4.7,
  },
  {
    name: $localize`:@@reviewNamePreparation4:Lisa Thompson`,
    age: 45,
    message: $localize`:@@reviewPreparation4:As a busy mom, I never find time to sit and read. Now I listen while cooking dinner and have gone through my entire reading backlog!`,
    avatarUrl: 'assets/img/avatars/girl1.jpg',
    rate: 4.9,
  },
  {
    name: $localize`:@@reviewNamePreparation5:Daniel Warner`,
    age: 37,
    message: $localize`:@@reviewPreparation5:I was skeptical about AI voices, but these sound incredibly human. I've replaced my morning social media habit with listening to articles.`,
    avatarUrl: 'assets/img/avatars/m2.jpg',
    rate: 4.6,
  },
  {
    name: $localize`:@@reviewNamePreparation6:Jennifer Parker`,
    age: 48,
    message: $localize`:@@reviewPreparation6:Reading gives me headaches after 20 minutes. With audio, I can absorb content for hours while walking or doing chores.`,
    avatarUrl: 'assets/img/avatars/w4.jpg',
    rate: 5.0,
  },
  {
    name: $localize`:@@reviewNamePreparation7:Robert Kincaid`,
    age: 33,
    message: $localize`:@@reviewPreparation7:The time savings are incredible. I process twice as much information now by listening during my daily routine.`,
    avatarUrl: 'assets/img/avatars/boy1.jpg',
    rate: 4.8,
  },
  {
    name: $localize`:@@reviewNamePreparation8:Karen Lawson`,
    age: 47,
    message: $localize`:@@reviewPreparation8:I can finally keep up with industry articles while multitasking. The voice quality makes it easy to listen for extended periods.`,
    avatarUrl: 'assets/img/avatars/w3.jpg',
    rate: 4.7,
  },
];
